/* eslint-disable no-console */
/** @ts-check */

(function () {
  "use strict";

  /* =============================== 
     MINI CART MAIN TABS (Cart / Auctions) 
  ============================== */ 
  /**
   * @param {HTMLElement} root
   * @param {"cart"|"auctions"} name
   */
  function setMiniCartActiveTab(root, name) {
    const tabs = Array.from(root.querySelectorAll("[data-bv-tab]"));
    const panels = Array.from(root.querySelectorAll("[data-bv-panel]"));
    if (!tabs.length || !panels.length) return;

    tabs.forEach((btn) => {
      const isActive = btn.getAttribute("data-bv-tab") === name;
      btn.classList.toggle("is-active", isActive);
      btn.setAttribute("aria-selected", isActive ? "true" : "false");
    });

    panels.forEach((panel) => {
      const isActive = panel.getAttribute("data-bv-panel") === name;
      panel.classList.toggle("is-active", isActive);
      panel.setAttribute("aria-hidden", isActive ? "false" : "true");
    });

    if (name === "auctions") {
      const target = document.querySelector(".wishlist-replace");
      if (target) loadMinicartWishlist(target);
    }
  }

  /** 
   * @param {HTMLElement} root 
   */ 
  function initMiniCartTabs(root) { 
    const tabs = Array.from(root.querySelectorAll("[data-bv-tab]")); 
    const panels = Array.from(root.querySelectorAll("[data-bv-panel]")); 
    if (!tabs.length || !panels.length) return; 

    /** 
     * @param {string} name 
     */ 
    function activate(name) { 
      setMiniCartActiveTab(root, /** @type {"cart"|"auctions"} */ (name)); 
    } 

    tabs.forEach((btn) => {
      btn.addEventListener("click", () => {
        const tab = btn.getAttribute("data-bv-tab");
        if (tab === "cart" || tab === "auctions") activate(tab);
      });
    });

    activate("cart"); 
  } 

  function bootTabs() {
    document.querySelectorAll(".bv-mini-cart").forEach(initMiniCartTabs);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bootTabs);
  } else {
    bootTabs();
  }

  document.addEventListener("shopify:section:load", bootTabs); 

  // Always reset to Cart tab when drawer opens to prevent flicker from the last active tab.
  document.addEventListener("cart-drawer:open", () => {
    document.querySelectorAll(".bv-mini-cart").forEach((root) => {
      if (root instanceof HTMLElement) setMiniCartActiveTab(root, "cart");
    });
  });

  let cartPriceRefreshInFlight = false;

  function getCartSectionIds() {
    const sectionIds = Array.from(document.querySelectorAll("cart-items-component[data-section-id]"))
      .map((element) => element.getAttribute("data-section-id"))
      .filter(Boolean);

    if (!sectionIds.includes("cart-drawer")) {
      sectionIds.push("cart-drawer");
    }

    return sectionIds.filter((id, index, arr) => arr.indexOf(id) === index);
  }

  async function refreshCartDrawerPricesOnOpen() {
    if (cartPriceRefreshInFlight) return;

    cartPriceRefreshInFlight = true;
    window.__BV_CART_PRICE_REFRESH_UNTIL = Date.now() + 1500;

    try {
      const cartResponse = await fetch("/cart.js", {
        credentials: "same-origin",
        cache: "no-store",
        headers: { Accept: "application/json" }
      });

      if (!cartResponse.ok) {
        throw new Error("Cart state could not be loaded");
      }

      const cart = await cartResponse.json();
      const items = Array.isArray(cart && cart.items) ? cart.items : [];
      const sections = getCartSectionIds();
      const updates = {};

      items.forEach((item) => {
        if (item && item.key) {
          updates[item.key] = item.quantity;
        }
      });

      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json"
        },
        body: JSON.stringify({
          updates,
          sections: sections.join(","),
          sections_url: window.location.pathname
        })
      });

      const updatedCart = await updateResponse.json();

      if (!updateResponse.ok) {
        throw new Error(updatedCart.description || updatedCart.message || "Cart prices could not be refreshed");
      }

      document.dispatchEvent(new CustomEvent("cart:update", {
        detail: {
          data: {
            itemCount: Number(updatedCart.item_count) || 0,
            source: "cart-price-refresh",
            sections: updatedCart.sections || {}
          },
          cart: updatedCart
        }
      }));

      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: updatedCart } }));
    } catch (error) {
      console.warn("[BV Mini Cart] Cart price refresh failed:", error);
    } finally {
      cartPriceRefreshInFlight = false;
      window.__BV_CART_PRICE_REFRESH_UNTIL = Date.now() + 300;
    }
  }

  document.addEventListener("cart-drawer:open", refreshCartDrawerPricesOnOpen);

  /* ===============================
     BV CART PROGRESS — UNIVERSAL (MINI + MAIN CART)
  ============================== */

  // Progress bar code has been moved to bv-cart-progress.js

  /* ===============================
     CHECKOUT GUARD — OUT OF STOCK (MINI CART)
  ============================== */

  /**
   * @param {Element} el
   * @returns {HTMLElement | null}
   */
  function closestCartDrawer(el) {
    const drawer = el.closest("cart-drawer-component");
    return drawer instanceof HTMLElement ? drawer : null;
  }

 let minicartWishlistLoading = false;

function getWishlistApiUrl(endpoint = "") {
  const proxy = window.WISHLIST_PROXY || "/apps/wishlist";
  const baseUrl = proxy.endsWith("/") ? proxy.slice(0, -1) : proxy;
  const path = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;

  return `${baseUrl}${path}`;
}

function escapeHtml(value) {
  return String(value || "")
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}

function formatEuro(value) {
  const number = Number(value || 0);

  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR"
  }).format(number);
}

function renderWishlistProduct(item) {
  const variant = item.variant;

  if (!variant || !variant.id) {
    return "";
  }

  const productUrl = `/products/${item.handle}?variant=${variant.id}`;
  const title = item.title || "Untitled product";
  const image = variant.image || window.themeAssetUrls?.noImage || "/assets/icon-noimage.png";
  const price = Number(variant.price || 0);
  const compareAtPrice = Number(variant.compareAtPrice || 0);
  const showCompareAtPrice = compareAtPrice > price;

  const availableForSale = variant.availableForSale !== false && Number(variant.quantity || 0) > 0;

  return `
    <div
      class="cart-wishlist__product wishlist-product"
      data-pid="${escapeHtml(item.productId)}"
      data-product-id="${escapeHtml(item.productId)}"
      data-variant-id="${escapeHtml(variant.id)}"
    >
      <div class="wishlist-product__image">
        <a href="${productUrl}">
          <img
            class="wishlist-product__image-img"
            src="${escapeHtml(image)}"
            alt="${escapeHtml(title)}"
            title="${escapeHtml(title)}"
            loading="lazy"
          >
        </a>
      </div>

      <div class="wishlist-product__content">
        <div class="wishlist-product__header">
          <div class="wishlist-product__name">
            <a href="${productUrl}">
              ${escapeHtml(title)}
            </a>
          </div>

          <div class="wishlist-product__remove">
            <button
              type="button"
              class="js-remove-from-wishlist"
              data-variant-id="${escapeHtml(variant.id)}"
              aria-label="Remove from wishlist"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 6.09091H20M9.76136 15.9432V10.1477M13.2386 15.9432V10.1477M13.2386 3H9.76136C9.45395 3 9.15913 3.12212 8.94176 3.33949C8.72439 3.55686 8.60227 3.85168 8.60227 4.15909V6.09091H14.3977V4.15909C14.3977 3.85168 14.2756 3.55686 14.0582 3.33949C13.8409 3.12212 13.546 3 13.2386 3ZM16.8009 18.9336C16.7794 19.224 16.6487 19.4955 16.435 19.6934C16.2214 19.8912 15.9407 20.0008 15.6495 20H7.35045C7.05927 20.0008 6.77859 19.8912 6.56495 19.6934C6.35132 19.4955 6.22059 19.224 6.19909 18.9336L5.125 6.09091H17.875L16.8009 18.9336Z" stroke="#191919" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </button>
          </div>
        </div>

        <div class="wishlist-product__prices">
          <div class="wishlist-product__price salesPrice">
            ${formatEuro(price)}
          </div>

          ${
            showCompareAtPrice
              ? `<div class="wishlist-product__price listPrice">${formatEuro(compareAtPrice)}</div>`
              : `<div class="wishlist-product__price originalPrice d-none"></div>`
          }
        </div>

        ${
          variant.title && variant.title !== "Default Title"
            ? `
              <div class="wishlist-product__attributes">
                <div class="wishlist-product__attribute">
                  Größe: ${escapeHtml(variant.title)}
                </div>
              </div>
            `
            : ""
        }

        <div class="error-message"></div>

        <div class="wishlist-product__button">
          <button
            type="button"
            class="js-add-to-cart"
            data-variant-id="${escapeHtml(variant.id)}"
            ${
              Number(variant.quantity) > 0
                ? `data-quantity-left="${escapeHtml(String(Number(variant.quantity)))}"`
                : ""
            }
            ${availableForSale ? "" : "disabled"}
          >
            <span>${availableForSale ? "In den Warenkorb" : "Ausverkauft"}</span>
          </button>
        </div>
      </div>
    </div>
  `;
}

function renderWishlistShell(itemsHtml, isEmpty = false) {
  return `
    <div class="cart-wishlist js-wishlist-container">
      <div class="cart-wishlist__messages" style="display:none;">
        <div class="cart-wishlist__messages-text">
          <span>Dieser Artikel wurde Ihrem Warenkorb hinzugefügt.</span>
        </div>
      </div>

      <div class="cart-wishlist__products" ${isEmpty ? 'style="display:none;"' : ""}>
        ${itemsHtml}
      </div>

      <div class="cart-wishlist__empty empty" ${isEmpty ? "" : 'style="display:none;"'}>
        <div class="minicart-text-container">
          Sieht aus, als wäre Ihre Wunschliste leer -
          <a href="/collections/all" class="link bold">
            finden Sie etwas, das Sie lieben werden, aus unseren Top-Tipps.
          </a>
        </div>
      </div>
    </div>
  `;
}

async function loadMinicartWishlist(target) {
  if (minicartWishlistLoading) return;

  // Never load wishlist for guests
  const injector = document.querySelector('[data-wishlist-injector]');
  if (!injector || !injector.getAttribute('data-customer-email')) return;

  minicartWishlistLoading = true;

  target.innerHTML = `
    <div class="cart-wishlist">
      <div class="cart-wishlist__products">
        Loading...
      </div>
    </div>
  `;

  try {
    const url = `${getWishlistApiUrl("v1/list")}?page=1&limit=20&moreInfo=true`;

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "x-client-type": "web"
      },
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error(`Wishlist request failed: ${response.status}`);
    }

    const result = await response.json();
    const items = result?.data?.items || [];

    if (!items.length) {
      target.innerHTML = renderWishlistShell("", true);
      return;
    }

    const itemsHtml = items.map(renderWishlistProduct).join("");
    target.innerHTML = renderWishlistShell(itemsHtml, false);

    attachMinicartWishlistRemoveHandlers(target);
    attachMinicartWishlistAddToCartHandlers(target);
  } catch (error) {
    console.error("[Minicart Wishlist] Failed to load wishlist:", error);

    target.innerHTML = `
      <div class="cart-wishlist">
        <div class="cart-wishlist__products">
          Wishlist could not be loaded.
        </div>
      </div>
    `;
  } finally {
    minicartWishlistLoading = false;
  }
}

function attachMinicartWishlistRemoveHandlers(container) {
  container.querySelectorAll(".js-remove-from-wishlist").forEach((button) => {
    button.addEventListener("click", async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.dataset.variantId;

      if (!variantId) return;

      this.disabled = true;

      try {
        const response = await fetch(getWishlistApiUrl(`v1/${variantId}`), {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            "x-client-type": "web"
          },
          credentials: "same-origin"
        });

        if (!response.ok) {
          throw new Error(`Remove failed: ${response.status}`);
        }

        const result = await response.json();

        if (!result.success) {
          throw new Error(result.error || "Failed to remove wishlist item");
        }

        document.dispatchEvent(new CustomEvent("wishlist:updated", {
          detail: {
            action: "removed",
            variantId
          }
        }));

        const target = document.querySelector(".wishlist-replace");

        if (target) {
          await loadMinicartWishlist(target);
        }
      } catch (error) {
        console.error("[Minicart Wishlist] Remove failed:", error);
        this.disabled = false;
      }
    });
  });
}

function attachMinicartWishlistAddToCartHandlers(container) {
  container.querySelectorAll(".js-add-to-cart").forEach((button) => {
    button.addEventListener("click", async function (event) {
      event.preventDefault();
      event.stopPropagation();

      const variantId = this.dataset.variantId;

      if (!variantId) return;

      this.disabled = true;

      const minicartComponent = document.querySelector(".cart-items-component");
      const minicartItems = minicartComponent?.querySelectorAll(`.cart-items__wrapper .mini-cart-item[data-variant-id='${variantId}']`);

      // Stock limit for this variant. When the variant is already in the mini cart we read it from
      // the row (data-quantity-left); otherwise there is no row yet, so fall back to the quantity
      // the wishlist API reported for this button. Without that fallback the very first add was
      // never validated at all — the guard below used to sit inside `if (minicartItems?.length)`.
      let quantityLeft = this.getAttribute("data-quantity-left");
      let itemTotalQuantity = 0;

      minicartItems?.forEach((minicartItem) => {
        const rowQuantityLeft = minicartItem.getAttribute("data-quantity-left");
        if (rowQuantityLeft) quantityLeft = rowQuantityLeft;

        const minicartItemAddedQuantity = minicartItem.getAttribute("data-item-quantity");

        if (minicartItemAddedQuantity && +minicartItemAddedQuantity) {
          itemTotalQuantity += +minicartItemAddedQuantity;
        }
      });

      // No limit published for this variant -> behave exactly as before and let the add through.
      if (+quantityLeft > 0 && itemTotalQuantity + 1 > +quantityLeft) {
        const wishlistItemComponent = this.closest(".wishlist-product__content");
        const errorMessageComponent = wishlistItemComponent?.querySelector(".error-message");
        const errorMessageText =
          document.querySelector(".wishlist-replace")?.getAttribute("data-exceeded-item-quantity-error") || "";

        if (errorMessageComponent) {
          if (errorMessageText) {
            errorMessageComponent.innerHTML = errorMessageText;
          }

          errorMessageComponent.classList.add("shown");

          setTimeout(() => {
            errorMessageComponent.classList.remove("shown");
          }, 1000);
        }

        this.disabled = false;

        return;
      }

      try {
        const response = await fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json"
          },
          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: 1
              }
            ]
          })
        });

        if (!response.ok) {
          throw new Error(`Add to cart failed: ${response.status}`);
        }

        const wishlist = this.closest(".cart-wishlist");
        const message = wishlist?.querySelector(".cart-wishlist__messages");

        if (message) {
          message.style.display = "block";
        }

        document.dispatchEvent(new CustomEvent("cart:update"));
        document.dispatchEvent(new CustomEvent("cart:updated"));
      } catch (error) {
        console.error("[Minicart Wishlist] Add to cart failed:", error);
        this.disabled = false;
      }
    });
  });
}

  /**
   * @param {HTMLElement} drawer
   * @returns {HTMLElement | null}
   */
  function findCheckoutErrorEl(drawer) {
    const el = drawer.querySelector(".cart__checkout-error");
    return el instanceof HTMLElement ? el : null;
  }

  /**
   * @param {HTMLElement} drawer
   * @returns {HTMLElement | null}
   */
  function findFirstOutOfStockItem(drawer) {
    const item = drawer.querySelector(".mini-cart-item.out-of-stock");
    return item instanceof HTMLElement ? item : null;
  }

  /**
   * @param {HTMLElement} drawer
   * @param {string} message
   */
  function showCheckoutError(drawer, message) {
    const errorEl = findCheckoutErrorEl(drawer);
    if (!errorEl) {
      window.alert(message);
      return;
    }

    errorEl.textContent = message;
    errorEl.classList.remove("hidden");
  }

  /**
   * @param {HTMLElement} drawer
   */
  function maybeHideCheckoutError(drawer) {
    const errorEl = findCheckoutErrorEl(drawer);
    if (!errorEl) return;

    if (!findFirstOutOfStockItem(drawer)) {
      errorEl.classList.add("hidden");
      errorEl.textContent = "";
    }
  }

  /**
   * @param {HTMLElement} drawer
   * @param {HTMLElement} checkoutButton
   * @returns {boolean} true if checkout may proceed
   */
  function guardCheckoutIfOutOfStock(drawer, checkoutButton) {
    const outOfStockItem = findFirstOutOfStockItem(drawer);
    if (!outOfStockItem) return true;

    const message =
      checkoutButton.getAttribute("data-oos-checkout-message") ||
      "Bitte entfernen Sie nicht verfuegbare Artikel aus dem Warenkorb, um zur Kasse zu gehen.";

    showCheckoutError(drawer, message);

    outOfStockItem.classList.add("bv-oos-highlight");
    outOfStockItem.scrollIntoView({ behavior: "smooth", block: "center" });
    window.setTimeout(() => outOfStockItem.classList.remove("bv-oos-highlight"), 1800);

    return false;
  }

  (function bootCheckoutGuard() {
    document.addEventListener(
      "click",
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) return;

        const button = target.closest('button[name="checkout"], button#checkout, .cart__checkout-button');
        if (!(button instanceof HTMLElement)) return;

        const drawer = closestCartDrawer(button);
        if (!drawer) return;

        const shouldProceed = guardCheckoutIfOutOfStock(drawer, button);
        if (!shouldProceed) {
          event.preventDefault();
          event.stopPropagation();
          // @ts-ignore
          event.stopImmediatePropagation?.();
        }
      },
      true
    );

    document.addEventListener(
      "cart:update",
      () => {
        document.querySelectorAll("cart-drawer-component").forEach((drawer) => {
          if (drawer instanceof HTMLElement) maybeHideCheckoutError(drawer);
        });
      },
      false
    );
  })();

  /* ===============================
     MAX QUANTITY VALIDATION — MINI CART
  ============================== */

  /**
   * Get max quantity for a cart item
   * @param {HTMLElement} quantitySelector - The quantity selector component
   * @returns {number | null}
   */
  function getMaxQuantityForSelector(quantitySelector) {
    if (!(quantitySelector instanceof HTMLElement)) return null;
    
    const input = quantitySelector.querySelector('input[name="updates[]"]');
    if (!(input instanceof HTMLInputElement)) return null;
    
    const inventoryQty = parseInt(input.dataset.inventoryQuantity || '0', 10);
    const inventoryPolicy = input.dataset.inventoryPolicy;
    const maxAttr = input.getAttribute('max');
    const maxFromAttr = maxAttr ? parseInt(maxAttr, 10) : null;

    // Use the max attribute from the input
    let effectiveMax = maxFromAttr;

    // If inventory is managed with deny policy, use inventory_quantity as the limit
    if (inventoryPolicy === 'deny' && inventoryQty > 0) {
      if (effectiveMax === null) {
        effectiveMax = inventoryQty;
      } else {
        effectiveMax = Math.min(effectiveMax, inventoryQty);
      }
    }

    return effectiveMax;
  }

  /**
   * Show max quantity message below quantity selector
   * @param {HTMLElement} quantitySelector - The quantity selector component
   * @param {string} message - The message to show
   */
  function showMaxQtyMessageMiniCart(quantitySelector, message) {
    // The message element is a sibling of the quantity selector, inside cart-items__quantity-controls
    // Try multiple approaches to find it
    let messageEl = null;
    
    // Method 1: Look in the parent container (cart-items__quantity-controls)
    const parentContainer = quantitySelector.closest('.cart-items__quantity-controls');
    if (parentContainer) {
      messageEl = parentContainer.querySelector('[data-max-qty-message]');
    }
    
    // Method 2: Look for next sibling element
    if (!messageEl) {
      let sibling = quantitySelector.nextElementSibling;
      while (sibling) {
        if (sibling instanceof HTMLElement && sibling.hasAttribute('data-max-qty-message')) {
          messageEl = sibling;
          break;
        }
        sibling = sibling.nextElementSibling;
      }
    }
    
    // Method 3: Look in the cart item container
    if (!messageEl) {
      const cartItem = quantitySelector.closest('.cart-item, .bv-cart-item');
      if (cartItem) {
        messageEl = cartItem.querySelector('[data-max-qty-message]');
      }
    }
    
    if (messageEl instanceof HTMLElement) {
      messageEl.textContent = message;
      messageEl.style.display = 'block';
      messageEl.classList.add('bv-cart-item__max-qty-message--active');
      
      // Hide message after 5 seconds
      setTimeout(() => {
        if (messageEl instanceof HTMLElement) {
          messageEl.style.display = 'none';
          messageEl.classList.remove('bv-cart-item__max-qty-message--active');
        }
      }, 5000);
    }
  }

  /**
   * Get max quantity message from settings
   */
  function getMaxQtyMessage() {
    const cartDrawer = document.querySelector('.cart-drawer');
    if (cartDrawer instanceof HTMLElement && cartDrawer.dataset.maxQtyMessage) {
      return cartDrawer.dataset.maxQtyMessage;
    }
    // Fallback: try to get from cart page element (if available)
    const cartPage = document.querySelector('.bv-cart-page');
    if (cartPage instanceof HTMLElement && cartPage.dataset.maxQtyMessage) {
      return cartPage.dataset.maxQtyMessage;
    }
    return 'Maximum allowed quantity reached';
  }

  /**
   * Handle quantity selector updates in mini cart
   */
  // Get ThemeEvents from global scope
  // @ts-ignore
  const ThemeEvents = window.ThemeEvents || (window.Theme && window.Theme.events);
  // @ts-ignore
  const QuantitySelectorUpdateEvent = window.QuantitySelectorUpdateEvent || (window.Theme && window.Theme.events && window.Theme.events.QuantitySelectorUpdateEvent);

  const quantitySelectorUpdateEventName = ThemeEvents?.quantitySelectorUpdate || 'quantity-selector:update';

  // Intercept button clicks before quantity selector processes them
  document.addEventListener('click', (e) => {
    if (!(e.target instanceof HTMLElement)) return;
    
    // Check if it's a quantity button in the cart drawer
    const button = e.target.closest('button[name="minus"], button[name="plus"]');
    if (!button || !(button instanceof HTMLButtonElement)) return;
    
    const quantitySelector = button.closest('quantity-selector-component') || 
                             button.closest('cart-quantity-selector-component') ||
                             button.closest('.quantity-selector');
    
    if (!quantitySelector || !(quantitySelector instanceof HTMLElement)) return;
    
    // Only handle in mini cart (cart drawer)
    const cartDrawer = quantitySelector.closest('.cart-drawer');
    if (!cartDrawer) return;

    const input = quantitySelector.querySelector('input[name="updates[]"]');
    if (!(input instanceof HTMLInputElement)) return;

    const currentQuantity = parseInt(input.value, 10) || 1;
    const maxQty = getMaxQuantityForSelector(quantitySelector);
    const isPlusButton = button.name === 'plus';

    // Check if trying to increase beyond max
    if (isPlusButton && maxQty !== null && currentQuantity >= maxQty) {
      e.preventDefault();
      e.stopPropagation();
      
      console.log('[BV Mini Cart] Max quantity reached, preventing increase');
      const message = getMaxQtyMessage();
      showMaxQtyMessageMiniCart(quantitySelector, message);
      return false;
    }
    
    // If not at max, let the event continue to the component
    // Also ensure button states are updated after the component processes the click
    setTimeout(() => {
      const component = /** @type {any} */ (quantitySelector);
      if (component && typeof component.updateButtonStates === 'function') {
        component.updateButtonStates();
      }
    }, 50);
  }, true); // Use capture phase to intercept before component handles it

  // Also listen to quantity selector update events for input changes
  document.addEventListener(quantitySelectorUpdateEventName, (e) => {
    // Handle both QuantitySelectorUpdateEvent and CustomEvent
    if (!(e instanceof Event)) return;
    
    // Get the quantity from event detail (if it's a CustomEvent)
    let quantity = undefined;
    if (e instanceof CustomEvent && e.detail) {
      quantity = e.detail.quantity;
    }
    
    // Find the quantity selector component (event target or closest)
    let quantitySelector = null;
    if (e.target instanceof HTMLElement) {
      // Try to find the quantity-selector-component
      quantitySelector = e.target.closest('quantity-selector-component') || 
                         e.target.closest('cart-quantity-selector-component') ||
                         e.target.closest('.quantity-selector');
    }
    
    if (!quantitySelector || !(quantitySelector instanceof HTMLElement)) return;
    
    // Only handle updates in mini cart (cart drawer)
    const cartDrawer = quantitySelector.closest('.cart-drawer');
    if (!cartDrawer) return;

    const input = quantitySelector.querySelector('input[name="updates[]"]');
    if (!(input instanceof HTMLInputElement)) return;

    // Use quantity from event if available, otherwise get from input
    const currentQuantity = quantity !== undefined ? quantity : (parseInt(input.value, 10) || 1);
    const maxQty = getMaxQuantityForSelector(quantitySelector);

    // Ensure button states are updated after quantity change
    const component = /** @type {any} */ (quantitySelector);
    if (component && typeof component.updateButtonStates === 'function') {
      component.updateButtonStates();
    }

    // Check if the quantity equals max (meaning user tried to exceed but was clamped)
    const inputMax = input.getAttribute('max');
    const inputMaxQty = inputMax ? parseInt(inputMax, 10) : null;
    
    // If current quantity equals max and there's a max limit, show message
    if (maxQty !== null && currentQuantity === maxQty && inputMaxQty === maxQty) {
      const previousValue = input.dataset.previousValue;
      if (previousValue && parseInt(previousValue, 10) < maxQty) {
        // User tried to increase beyond max
        console.log('[BV Mini Cart] Max quantity reached via input change');
        const message = getMaxQtyMessage();
        showMaxQtyMessageMiniCart(quantitySelector, message);
      }
    }
    
    // Store current value for next comparison
    input.dataset.previousValue = String(currentQuantity);
    
    // Hide max qty message if quantity is below max
    if (maxQty === null || currentQuantity < maxQty) {
      const messageEl = quantitySelector.parentElement?.querySelector('[data-max-qty-message]');
      if (messageEl instanceof HTMLElement) {
        messageEl.style.display = 'none';
        messageEl.classList.remove('bv-cart-item__max-qty-message--active');
      }
    }
  }, true); // Use capture phase to catch event early

  // Update button states after cart update
  document.addEventListener("cart:update", () => {
    // Update button states for all quantity selectors in mini cart
    requestAnimationFrame(() => {
      setTimeout(() => {
        const quantitySelectors = document.querySelectorAll('.cart-drawer quantity-selector-component, .cart-drawer cart-quantity-selector-component');
        quantitySelectors.forEach((selector) => {
          if (selector instanceof HTMLElement) {
            const component = /** @type {any} */ (selector);
            if (component && typeof component.updateButtonStates === 'function') {
              component.updateButtonStates();
            }
          }
        });
      }, 100);
    });
  });

  /* ===============================
     CART IMAGE PLACEHOLDER HANDLING
  ============================== */

  /**
   * Handle image load errors by replacing with placeholder
   * @param {HTMLImageElement} img - The image element that failed to load
   */
  function handleImageError(img) {
    if (!(img instanceof HTMLImageElement)) return;
    
    // Don't replace if already showing placeholder
    if (img.src.includes('no-image')) return;
    
    // Get placeholder URLs from data attributes or construct from asset path
    const placeholderSmall = img.dataset.placeholderSmall || '/assets/no-image-small.jpg';
    const placeholderLarge = img.dataset.placeholderLarge || '/assets/no-image-large.jpg';
    
    // Determine which placeholder to use based on viewport
    const isMobile = window.innerWidth <= 749;
    const placeholderSrc = isMobile ? placeholderSmall : placeholderLarge;
    
    // Replace with placeholder
    img.src = placeholderSrc;
    img.alt = img.alt || 'Product image not available';
    
    // Prevent infinite loop if placeholder also fails
    img.onerror = null;
  }

  /**
   * Initialize image error handlers for cart images
   */
  function initCartImageErrorHandlers() {
    // Handle existing images
    const cartImages = document.querySelectorAll('.cart-items__media-image, .bv-cart-item__image img');
    cartImages.forEach((img) => {
      if (img instanceof HTMLImageElement) {
        // Only add handler if image hasn't loaded yet or if it might fail
        if (!img.complete || img.naturalHeight === 0) {
          img.addEventListener('error', () => handleImageError(img), { once: true });
        }
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initCartImageErrorHandlers);
  } else {
    initCartImageErrorHandlers();
  }

  // Re-initialize when cart is updated
  document.addEventListener("cart:update", () => {
    setTimeout(initCartImageErrorHandlers, 200);
  });

  document.addEventListener("cart:refresh", () => {
    setTimeout(initCartImageErrorHandlers, 200);
  });

  // Also initialize when cart drawer opens
  document.addEventListener("cart-drawer:open", () => {
    setTimeout(initCartImageErrorHandlers, 200);
  });

  // Use MutationObserver to catch dynamically added images
  const cartImageObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof HTMLElement) {
            const images = node.querySelectorAll ? node.querySelectorAll('.cart-items__media-image, .bv-cart-item__image img') : [];
            images.forEach((img) => {
              if (img instanceof HTMLImageElement) {
                img.addEventListener('error', () => handleImageError(img), { once: true });
              }
            });
            
            // Also check if the node itself is an image
            if (node instanceof HTMLImageElement && 
                (node.classList.contains('cart-items__media-image') || 
                 node.closest('.bv-cart-item__image'))) {
              node.addEventListener('error', () => handleImageError(node), { once: true });
            }
          }
        });
      }
    });
  });

  // Observe cart drawer and cart page for image additions
  function setupCartImageObserver() {
    const cartDrawer = document.querySelector('cart-drawer-component');
    const cartPage = document.querySelector('.bv-cart-page');
    
    if (cartDrawer instanceof HTMLElement) {
      cartImageObserver.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }
    
    if (cartPage instanceof HTMLElement) {
      cartImageObserver.observe(cartPage, {
        childList: true,
        subtree: true
      });
    }
  }

  // Set up observer when DOM is ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setupCartImageObserver);
  } else {
    setupCartImageObserver();
  }

  // Also set up when cart section loads
  document.addEventListener('shopify:section:load', (e) => {
    if (e instanceof CustomEvent && e.detail && e.detail.sectionId && e.detail.sectionId.includes('cart')) {
      setTimeout(() => {
        setupCartImageObserver();
        initCartImageErrorHandlers();
      }, 100);
    }
  });

  /* ===============================
     REMOVE DRAFT PRODUCTS FROM CART
  ============================== */

  /**
   * Remove draft products from cart
   * Draft products should not be visible on live website
   */
  async function removeDraftProductsFromCart() {
    // Find all draft product items
    const draftItems = document.querySelectorAll('[data-is-draft="true"]');
    
    if (draftItems.length === 0) {
      return; // No draft products found
    }

    // Get section ID for cart updates
    const cartItemsComponent = document.querySelector('cart-items-component');
    const sectionId = (cartItemsComponent instanceof HTMLElement && cartItemsComponent.dataset.sectionId) || 'main-cart';
    
    // Collect all line numbers to remove
    /** @type {number[]} */
    const linesToRemove = [];
    draftItems.forEach((item) => {
      if (item instanceof HTMLElement) {
        const lineNumber = parseInt(item.dataset.line || '0', 10);
        if (lineNumber > 0) {
          linesToRemove.push(lineNumber);
        }
      }
    });

    if (linesToRemove.length === 0) {
      return; // No valid line numbers found
    }

    // Remove draft products one by one (Shopify API requires individual calls)
    // Process in reverse order to avoid line number shifting issues
    const sortedLines = [...linesToRemove].sort((a, b) => b - a);
    
    for (const line of sortedLines) {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            line: line,
            quantity: 0,
            sections: sectionId,
            sections_url: window.location.pathname,
          })
        });

        if (!response.ok) {
          console.warn('[BV Cart] Failed to remove draft product at line', line);
          continue;
        }

        const responseText = await response.text();
        const parsedResponse = JSON.parse(responseText);

        // Update cart section if response includes sections
        if (parsedResponse.sections && parsedResponse.sections[sectionId]) {
          // Use morphSection if available, otherwise fallback to innerHTML
          // @ts-ignore
          if (window.morphSection || (window.Theme && window.Theme.morphSection)) {
            // @ts-ignore
            const morphSection = window.morphSection || window.Theme.morphSection;
            try {
              morphSection(sectionId, parsedResponse.sections[sectionId]);
            } catch (error) {
              console.warn('[BV Cart] Error morphing section:', error);
              // Fallback to innerHTML update
              const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
              if (sectionElement && parsedResponse.sections[sectionId]) {
                sectionElement.innerHTML = parsedResponse.sections[sectionId];
              }
            }
          } else {
            // Fallback: use innerHTML update
            const sectionElement = document.getElementById(`shopify-section-${sectionId}`);
            if (sectionElement && parsedResponse.sections[sectionId]) {
              sectionElement.innerHTML = parsedResponse.sections[sectionId];
            }
          }
        }

        // Dispatch cart update event
        // @ts-ignore
        const CartUpdateEvent = window.CartUpdateEvent || (window.Theme && window.Theme.events && window.Theme.events.CartUpdateEvent);
        // @ts-ignore
        const ThemeEvents = window.ThemeEvents || (window.Theme && window.Theme.events);
        
        if (CartUpdateEvent) {
          document.dispatchEvent(
            new CartUpdateEvent(parsedResponse, sectionId, {
              source: 'bv-draft-product-removal',
              sections: parsedResponse.sections,
            })
          );
        } else if (ThemeEvents && ThemeEvents.cartUpdate) {
          document.dispatchEvent(new CustomEvent(ThemeEvents.cartUpdate, {
            detail: {
              data: parsedResponse,
              source: 'bv-draft-product-removal',
              sections: parsedResponse.sections,
            }
          }));
        } else {
          document.dispatchEvent(new CustomEvent('cart:update', {
            detail: {
              data: parsedResponse,
              source: 'bv-draft-product-removal',
              sections: parsedResponse.sections,
            }
          }));
        }

        // Small delay between removals to avoid rate limiting
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        console.error('[BV Cart] Error removing draft product at line', line, ':', error);
      }
    }
  }

  // Initialize draft product removal on DOM ready
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      setTimeout(removeDraftProductsFromCart, 500);
    });
  } else {
    setTimeout(removeDraftProductsFromCart, 500);
  }

  // Also remove draft products when cart is updated or refreshed
  document.addEventListener("cart:update", () => {
    setTimeout(removeDraftProductsFromCart, 300);
  });

  document.addEventListener("cart:refresh", () => {
    setTimeout(removeDraftProductsFromCart, 300);
  });

  // Remove draft products when cart drawer opens
  document.addEventListener("cart-drawer:open", () => {
    setTimeout(removeDraftProductsFromCart, 300);
  });

  // Remove draft products when Shopify section loads
  document.addEventListener('shopify:section:load', (e) => {
    if (e instanceof CustomEvent && e.detail && e.detail.sectionId && e.detail.sectionId.includes('cart')) {
      setTimeout(removeDraftProductsFromCart, 300);
    }
  });

  /* ===============================
     REBUY CART SYNC (MINI CART)
  ============================== */

  function getCartForExternalUpdate() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then((response) => response.json());
  }

  function getSectionHtmlForExternalUpdate(sectionId) {
    const url = new URL(window.location.href);
    url.searchParams.set('section_id', sectionId);

    return fetch(url.toString(), { credentials: 'same-origin' }).then((response) => response.text());
  }

  function refreshCartAfterExternalAdd(source = 'rebuy') {
    return getCartForExternalUpdate()
      .then((cart) => {
        const itemCount = Number(cart && cart.item_count) || 0;
        let sectionIds = Array.from(document.querySelectorAll('cart-items-component[data-section-id]'))
          .map((element) => element.getAttribute('data-section-id'))
          .filter(Boolean);

        sectionIds = sectionIds.filter((id, index, arr) => arr.indexOf(id) === index);

        const sections = {};

        return Promise.all(
          sectionIds.map((id) =>
            getSectionHtmlForExternalUpdate(id).then((html) => {
              sections[id] = html;
            })
          )
        ).then(() => {
          document.dispatchEvent(new CustomEvent('cart:update', {
            detail: {
              data: { itemCount, source, sections },
              cart
            }
          }));

          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));

          const drawer = document.querySelector('cart-drawer-component');
          if (drawer && typeof /** @type {any} */ (drawer).open === 'function') {
            /** @type {any} */ (drawer).open();
          }
        });
      })
      .catch((error) => {
        console.warn('[BV Mini Cart] External cart refresh failed:', error);
      });
  }

  document.addEventListener('rebuy.add', () => {
    refreshCartAfterExternalAdd('rebuy');
  });
})();
